import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

import Cookies from "js-cookie";
import utf8 from "utf8";
import { act } from "react";
class CreditStore {
  credits = [];
  distributorsComps = [];

  logoFromDb = [];
  rec = 0;

  editedRecord_Id = "";

  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  excelLoadig = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
     
      distributorsComps: observable,

      logoFromDb: observable,

      editedRecord_Id: observable,

      rec: observable,

      total: observable,
      loading: observable,
      excelLoadig: observable,
      loadData: action,
      searchCreditRequest:action,
      getVehicleCreditRecords : action,
      getDistributorCompanies:action,
      addData: action,
      requestCredit: action,
      editData: action,
      setLogoFromDb: action
     

  
    });
    this.rootStore = rootStore;
  }

   async setLogoFromDb(logo) {
    this.logoFromDb = { fileList: logo };
    console.log(logo);
  }

  async loadData({
    offset,
    limit,
    distCompanyId,
    creditType
  }) {
    this.loading = true;

    var postData = {
      companyId:distCompanyId,
       creditType:creditType,
      offset: offset,
      limit: limit,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=getCreditRecord", "postData=" + base64Input);

    console.log(response)  
   // console.log("company Data", response?.data?.data?.companydata);
    this.credits = response?.data?.data?.creditrecord;
;
    console.log(response?.data?.data?.companydata);
    if (this.companies?.length > 0) {
      this.rec = 1;
    }

    //  this.setCompanies(response?.data?.data?.companydata);
    this.total = parseInt(response?.data?.data?.TotalCount);
    console.log(this.total);
    this.loading = false;
  }

  async searchCreditRequest({
    offset,
    limit,
    fromDate,
    toDate
  }) {
    this.loading = true;

    var postData = {
      fromDate:fromDate,
      toDate:toDate,
      offset: offset,
      limit: limit,
    };
    console.log(postData)
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=searchCreditRequest", "postData=" + base64Input);

    console.log(response)  
   // console.log("company Data", response?.data?.data?.companydata);
    this.credits = response?.data?.data?.creditreport;
;
    console.log(response?.data?.data?.companydata);
    if (this.companies?.length > 0) {
      this.rec = 1;
    }

    //  this.setCompanies(response?.data?.data?.companydata);
    this.total = parseInt(response?.data?.data?.TotalCount);
    console.log(this.total);
    this.loading = false;
  }

  

  async getVehicleCreditRecords({
    offset,
    limit,
    distCompanyId,
    creditType
  }) {
    this.loading = true;

    var postData = {
      companyId:distCompanyId,
       creditType:creditType,
      offset: offset,
      limit: limit,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=getVehicleCreditRecord", "postData=" + base64Input);

    console.log(response)  
   // console.log("company Data", response?.data?.data?.companydata);
    this.credits = response?.data?.data?.creditrecord;
;
    console.log(response?.data?.data?.companydata);
    if (this.companies?.length > 0) {
      this.rec = 1;
    }

    //  this.setCompanies(response?.data?.data?.companydata);
    this.total = parseInt(response?.data?.data?.TotalCount);
    console.log(this.total);
    this.loading = false;
  }

  async getDistributorCompanies(companyId){
       var postData = companyId;
    //console.log(postData);
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getDistributorCompanies", "postData=" + base2);
    
    let distributorsComps = [{"companyId":-1,"name":"All"}];
    this.distributorsComps = [...distributorsComps,...response?.data?.data?.companydetails];
    //this.setDistributor(distributors);

    return response.data.companydetails;
  }
  async addData(company) {
    var postData = company;
    //console.log(postData);
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));
    // const base64Input = await base64_encode(JSON.stringify(postData));
    console.log(postData.submitAction)
    if(postData.submitAction === "addCredit"){
      var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=addCredit", "postData=" + base2);
    }
     if(postData.submitAction === "deductCredit"){
      var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=deductCredit", "postData=" + base2);
    } 
    
    return response.data;
  }

    async requestCredit(company) {
    var postData = company;
    //console.log(postData);
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));
    // const base64Input = await base64_encode(JSON.stringify(postData));
    console.log(postData.submitAction)
    var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=addCreditDetails", "postData=" + base2);

    
    return response.data;
  }
  async downloadInvoice(invoice){

    var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=downloadInvoice&fname="+invoice);

  }
  async saveInvoice(invoice){
    var postData = invoice;
    //console.log(postData);
    const base64Input = await utf8.encode(JSON.stringify(postData));
    const base2 = JSON.stringify(base64_encode(base64Input));
    // const base64Input = await base64_encode(JSON.stringify(postData));
   if(postData.submitAction==='generate'){
      var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=saveinvoice", "postData=" + base2);
    }
    if(postData.submitAction==='sendinvoice'){
      var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=generateinvoice", "postData=" + base2);
    }
    return response.data;
    
  }
 

  async editData(creditId) {
    console.log(creditId)
    this.loading = true;

    var postData = {
      creditId:creditId,
     };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=credit&a=getCreditRecord", "postData=" + base64Input);

    console.log(response)  
   // console.log("company Data", response?.data?.data?.companydata);
    return response?.data?.data?.creditrecord[0];
  }





  async getCompanyDataById(companyId, showAll) {
    // console.log(isadmin);
    var postData = {
      value: companyId,
      getBy: "companyId",
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      companyId:
        JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 3
          ? companyId
          : null,
      showAll: showAll ? showAll : null,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getCompanyList", "postData=" + base64Input);
    return response.data.data.companies.map((user) => ({
      label: user.name,
      value: user.companyId,
    }));
  }



 
}

export default CreditStore;
